/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AIConnectionOffersResponse } from "../../models/aIConnectionOffersResponse.ts";

import type { AgentDetailsResponse } from "../../models/agentDetailsResponse.ts";

import type { AgentOutputResponse } from "../../models/agentOutputResponse.ts";

import type { AgentPreviewResponse } from "../../models/agentPreviewResponse.ts";

import type { AgentSavedResponse } from "../../models/agentSavedResponse.ts";

import type { AgentsFoundResponse } from "../../models/agentsFoundResponse.ts";

import type { AtResetRequest } from "../../models/atResetRequest.ts";

import type { AtResetTurn } from "../../models/atResetTurn.ts";

import type { AtResetTurnsResponse } from "../../models/atResetTurnsResponse.ts";

import type { BlockDetailsResponse } from "../../models/blockDetailsResponse.ts";

import type { BlockListResponse } from "../../models/blockListResponse.ts";

import type { BlockOutputResponse } from "../../models/blockOutputResponse.ts";

import type { CancelSessionResponse } from "../../models/cancelSessionResponse.ts";

import type { ChangeSessionConnectionRequest } from "../../models/changeSessionConnectionRequest.ts";

import type { ChatShareResponse } from "../../models/chatShareResponse.ts";

import type { ChatShareStateResponse } from "../../models/chatShareStateResponse.ts";

import type { ChatTransportsResponse } from "../../models/chatTransportsResponse.ts";

import type { ClarificationNeededResponse } from "../../models/clarificationNeededResponse.ts";

import type { CoPilotUsagePublic } from "../../models/coPilotUsagePublic.ts";

import type { ComputerInfo } from "../../models/computerInfo.ts";

import type { ContinueSessionRequest } from "../../models/continueSessionRequest.ts";

import type { ContinueSessionResponse } from "../../models/continueSessionResponse.ts";

import type { CreateSessionRequest } from "../../models/createSessionRequest.ts";

import type { CreateSessionResponse } from "../../models/createSessionResponse.ts";

import type { CredentialSelectionRequest } from "../../models/credentialSelectionRequest.ts";

import type { DesktopStream } from "../../models/desktopStream.ts";

import type { DocPageResponse } from "../../models/docPageResponse.ts";

import type { DocSearchResultsResponse } from "../../models/docSearchResultsResponse.ts";

import type { EnableShareRequest } from "../../models/enableShareRequest.ts";

import type { ErrorResponse } from "../../models/errorResponse.ts";

import type { ExecutionStartedResponse } from "../../models/executionStartedResponse.ts";

import type { ExpertOnboardingResponse } from "../../models/expertOnboardingResponse.ts";

import type { ExpertSoulUpdatedResponse } from "../../models/expertSoulUpdatedResponse.ts";

import type { GetV2GetSessionParams } from "../../models/getV2GetSessionParams.ts";

import type { GetV2GetSharedChatMessagesParams } from "../../models/getV2GetSharedChatMessagesParams.ts";

import type { GetV2GetTtlConfig200 } from "../../models/getV2GetTtlConfig200.ts";

import type { GetV2ListSessionsParams } from "../../models/getV2ListSessionsParams.ts";

import type { GetV2ResumeSessionStreamParams } from "../../models/getV2ResumeSessionStreamParams.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { InputValidationErrorResponse } from "../../models/inputValidationErrorResponse.ts";

import type { ListSessionsResponse } from "../../models/listSessionsResponse.ts";

import type { MCPToolOutputResponse } from "../../models/mCPToolOutputResponse.ts";

import type { MCPToolsDiscoveredResponse } from "../../models/mCPToolsDiscoveredResponse.ts";

import type { MemoryForgetCandidatesResponse } from "../../models/memoryForgetCandidatesResponse.ts";

import type { MemoryForgetConfirmResponse } from "../../models/memoryForgetConfirmResponse.ts";

import type { MemorySearchResponse } from "../../models/memorySearchResponse.ts";

import type { MemoryStoreResponse } from "../../models/memoryStoreResponse.ts";

import type { MessageFeedbackRequest } from "../../models/messageFeedbackRequest.ts";

import type { MessageFeedbackResponse } from "../../models/messageFeedbackResponse.ts";

import type { NeedLoginResponse } from "../../models/needLoginResponse.ts";

import type { NoResultsResponse } from "../../models/noResultsResponse.ts";

import type { PatchV2SessionAssignUser200 } from "../../models/patchV2SessionAssignUser200.ts";

import type { PatchV2UpdateSessionPinned200 } from "../../models/patchV2UpdateSessionPinned200.ts";

import type { PatchV2UpdateSessionTitle200 } from "../../models/patchV2UpdateSessionTitle200.ts";

import type { PeekPendingMessagesResponse } from "../../models/peekPendingMessagesResponse.ts";

import type { PresetDeletedResponse } from "../../models/presetDeletedResponse.ts";

import type { PresetListResponse } from "../../models/presetListResponse.ts";

import type { PresetUpdatedResponse } from "../../models/presetUpdatedResponse.ts";

import type { ProviderTiersResponse } from "../../models/providerTiersResponse.ts";

import type { PutV2ChangeTheConnectionAnExistingChatRunsOn200 } from "../../models/putV2ChangeTheConnectionAnExistingChatRunsOn200.ts";

import type { PutV2RecordCredentialPicksForThisChat200 } from "../../models/putV2RecordCredentialPicksForThisChat200.ts";

import type { QueuePendingMessageRequest } from "../../models/queuePendingMessageRequest.ts";

import type { QueuePendingMessageResponse } from "../../models/queuePendingMessageResponse.ts";

import type { RateLimitResetResponse } from "../../models/rateLimitResetResponse.ts";

import type { ScheduleDeletedResponse } from "../../models/scheduleDeletedResponse.ts";

import type { ScheduleListResponse } from "../../models/scheduleListResponse.ts";

import type { ScheduleToggledResponse } from "../../models/scheduleToggledResponse.ts";

import type { SessionDetailResponse } from "../../models/sessionDetailResponse.ts";

import type { SetDefaultTransportRequest } from "../../models/setDefaultTransportRequest.ts";

import type { SetupRequirementsResponse } from "../../models/setupRequirementsResponse.ts";

import type { SharedChatMessagesPage } from "../../models/sharedChatMessagesPage.ts";

import type { SharedChatSession } from "../../models/sharedChatSession.ts";

import type { SpeechRequest } from "../../models/speechRequest.ts";

import type { StreamChatRequest } from "../../models/streamChatRequest.ts";

import type { StreamResumeRefusal } from "../../models/streamResumeRefusal.ts";

import type { SuggestedGoalResponse } from "../../models/suggestedGoalResponse.ts";

import type { SuggestedPromptsResponse } from "../../models/suggestedPromptsResponse.ts";

import type { TaskDecompositionResponse } from "../../models/taskDecompositionResponse.ts";

import type { TodoWriteResponse } from "../../models/todoWriteResponse.ts";

import type { UnderstandingUpdatedResponse } from "../../models/understandingUpdatedResponse.ts";

import type { UpdateSessionPinnedRequest } from "../../models/updateSessionPinnedRequest.ts";

import type { UpdateSessionTitleRequest } from "../../models/updateSessionTitleRequest.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV2GetTtlConfigResponse200 = {
  data: GetV2GetTtlConfig200;
  status: 200;
};

export type getV2GetTtlConfigResponseSuccess = getV2GetTtlConfigResponse200 & {
  headers: Headers;
};
export type getV2GetTtlConfigResponse = getV2GetTtlConfigResponseSuccess;

export const getGetV2GetTtlConfigUrl = () => {
  return `/api/chat/config/ttl`;
};

/**
 * Get the stream TTL configuration.
 *
 * Returns the Time-To-Live settings for chat streams, which determines
 * how long clients can reconnect to an active stream.
 *
 * Returns:
 *     dict: TTL configuration with seconds and milliseconds values.
 * @summary Get Ttl Config
 */
export const getV2GetTtlConfig = async (
  options?: RequestInit,
): Promise<getV2GetTtlConfigResponse> => {
  return customMutator<getV2GetTtlConfigResponse>(getGetV2GetTtlConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetV2GetTtlConfigQueryKey = () => {
  return [`/api/chat/config/ttl`] as const;
};

export const getGetV2GetTtlConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetTtlConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2GetTtlConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetTtlConfig>>
  > = ({ signal }) => getV2GetTtlConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetTtlConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetTtlConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetTtlConfig>>
>;
export type GetV2GetTtlConfigQueryError = unknown;

export function useGetV2GetTtlConfig<
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetTtlConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetTtlConfig>>,
          TError,
          Awaited<ReturnType<typeof getV2GetTtlConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetTtlConfig<
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetTtlConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetTtlConfig>>,
          TError,
          Awaited<ReturnType<typeof getV2GetTtlConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetTtlConfig<
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetTtlConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Ttl Config
 */

export function useGetV2GetTtlConfig<
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetTtlConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetTtlConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Ttl Config
 */
export const prefetchGetV2GetTtlConfigQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetTtlConfig>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetTtlConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetTtlConfigQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListChatConnectionsResponse200 = {
  data: AIConnectionOffersResponse;
  status: 200;
};

export type getV2ListChatConnectionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListChatConnectionsResponseSuccess =
  getV2ListChatConnectionsResponse200 & {
    headers: Headers;
  };
export type getV2ListChatConnectionsResponseError =
  getV2ListChatConnectionsResponse401 & {
    headers: Headers;
  };

export type getV2ListChatConnectionsResponse =
  | getV2ListChatConnectionsResponseSuccess
  | getV2ListChatConnectionsResponseError;

export const getGetV2ListChatConnectionsUrl = () => {
  return `/api/chat/connections`;
};

/**
 * Every AI connection the user can chat over, described by the server.
 *
 * Additive alongside ``GET /transports``, which keeps its shape. This
 * carries what a client would otherwise have to infer — provider family,
 * what backs a run, the quality tiers, and the limitations that apply —
 * so product and billing statements come from the side that enforces them.
 * @summary List Chat Connections
 */
export const getV2ListChatConnections = async (
  options?: RequestInit,
): Promise<getV2ListChatConnectionsResponse> => {
  return customMutator<getV2ListChatConnectionsResponse>(
    getGetV2ListChatConnectionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListChatConnectionsQueryKey = () => {
  return [`/api/chat/connections`] as const;
};

export const getGetV2ListChatConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListChatConnections>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListChatConnectionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListChatConnections>>
  > = ({ signal }) => getV2ListChatConnections({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListChatConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListChatConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListChatConnections>>
>;
export type GetV2ListChatConnectionsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2ListChatConnections<
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListChatConnections>>,
          TError,
          Awaited<ReturnType<typeof getV2ListChatConnections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListChatConnections<
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListChatConnections>>,
          TError,
          Awaited<ReturnType<typeof getV2ListChatConnections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListChatConnections<
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Chat Connections
 */

export function useGetV2ListChatConnections<
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListChatConnectionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Chat Connections
 */
export const prefetchGetV2ListChatConnectionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListChatConnections>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatConnections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListChatConnectionsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListProviderModelTiersResponse200 = {
  data: ProviderTiersResponse;
  status: 200;
};

export type getV2ListProviderModelTiersResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListProviderModelTiersResponseSuccess =
  getV2ListProviderModelTiersResponse200 & {
    headers: Headers;
  };
export type getV2ListProviderModelTiersResponseError =
  getV2ListProviderModelTiersResponse401 & {
    headers: Headers;
  };

export type getV2ListProviderModelTiersResponse =
  | getV2ListProviderModelTiersResponseSuccess
  | getV2ListProviderModelTiersResponseError;

export const getGetV2ListProviderModelTiersUrl = () => {
  return `/api/chat/model-tiers`;
};

/**
 * What each provider's quality tiers resolve to, whoever you are.
 *
 * ``GET /connections`` answers "what can you pick", and deliberately omits
 * a connection nobody can select. That makes it the wrong source for the
 * surfaces that describe a provider *before* the user has one -- the
 * connect dialog, and the plan cards selling a plan they have not bought.
 * Those need "ChatGPT's Advanced tier is 5.6 Sol", which is a fact about
 * the catalog rather than about this user's entitlements.
 *
 * User-scoped only because the engine is: which model a tier maps to
 * depends on the path a turn will run on. Says nothing about access.
 * @summary List Provider Model Tiers
 */
export const getV2ListProviderModelTiers = async (
  options?: RequestInit,
): Promise<getV2ListProviderModelTiersResponse> => {
  return customMutator<getV2ListProviderModelTiersResponse>(
    getGetV2ListProviderModelTiersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListProviderModelTiersQueryKey = () => {
  return [`/api/chat/model-tiers`] as const;
};

export const getGetV2ListProviderModelTiersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListProviderModelTiersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListProviderModelTiers>>
  > = ({ signal }) =>
    getV2ListProviderModelTiers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListProviderModelTiersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListProviderModelTiers>>
>;
export type GetV2ListProviderModelTiersQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2ListProviderModelTiers<
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
          TError,
          Awaited<ReturnType<typeof getV2ListProviderModelTiers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListProviderModelTiers<
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
          TError,
          Awaited<ReturnType<typeof getV2ListProviderModelTiers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListProviderModelTiers<
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Provider Model Tiers
 */

export function useGetV2ListProviderModelTiers<
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListProviderModelTiersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Provider Model Tiers
 */
export const prefetchGetV2ListProviderModelTiersQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListProviderModelTiers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListProviderModelTiersQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2DummyToolResponseTypeExportForCodegenResponse200 = {
  data:
    | AgentsFoundResponse
    | NoResultsResponse
    | AgentDetailsResponse
    | SetupRequirementsResponse
    | ExecutionStartedResponse
    | NeedLoginResponse
    | ErrorResponse
    | InputValidationErrorResponse
    | AgentOutputResponse
    | UnderstandingUpdatedResponse
    | AgentPreviewResponse
    | AgentSavedResponse
    | ClarificationNeededResponse
    | SuggestedGoalResponse
    | BlockListResponse
    | BlockDetailsResponse
    | BlockOutputResponse
    | DocSearchResultsResponse
    | DocPageResponse
    | MCPToolsDiscoveredResponse
    | MCPToolOutputResponse
    | TaskDecompositionResponse
    | ScheduleListResponse
    | ScheduleDeletedResponse
    | ScheduleToggledResponse
    | PresetListResponse
    | PresetUpdatedResponse
    | PresetDeletedResponse
    | MemoryStoreResponse
    | MemorySearchResponse
    | MemoryForgetCandidatesResponse
    | MemoryForgetConfirmResponse
    | TodoWriteResponse
    | ExpertSoulUpdatedResponse
    | ExpertOnboardingResponse;
  status: 200;
};

export type getV2DummyToolResponseTypeExportForCodegenResponseSuccess =
  getV2DummyToolResponseTypeExportForCodegenResponse200 & {
    headers: Headers;
  };
export type getV2DummyToolResponseTypeExportForCodegenResponse =
  getV2DummyToolResponseTypeExportForCodegenResponseSuccess;

export const getGetV2DummyToolResponseTypeExportForCodegenUrl = () => {
  return `/api/chat/schema/tool-responses`;
};

/**
 * This endpoint is not meant to be called. It exists solely to expose tool response models in the OpenAPI schema for frontend codegen.
 * @summary [Dummy] Tool response type export for codegen
 */
export const getV2DummyToolResponseTypeExportForCodegen = async (
  options?: RequestInit,
): Promise<getV2DummyToolResponseTypeExportForCodegenResponse> => {
  return customMutator<getV2DummyToolResponseTypeExportForCodegenResponse>(
    getGetV2DummyToolResponseTypeExportForCodegenUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2DummyToolResponseTypeExportForCodegenQueryKey = () => {
  return [`/api/chat/schema/tool-responses`] as const;
};

export const getGetV2DummyToolResponseTypeExportForCodegenQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2DummyToolResponseTypeExportForCodegenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>
  > = ({ signal }) =>
    getV2DummyToolResponseTypeExportForCodegen({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2DummyToolResponseTypeExportForCodegenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>
>;
export type GetV2DummyToolResponseTypeExportForCodegenQueryError = unknown;

export function useGetV2DummyToolResponseTypeExportForCodegen<
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
          >,
          TError,
          Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2DummyToolResponseTypeExportForCodegen<
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
          >,
          TError,
          Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2DummyToolResponseTypeExportForCodegen<
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary [Dummy] Tool response type export for codegen
 */

export function useGetV2DummyToolResponseTypeExportForCodegen<
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV2DummyToolResponseTypeExportForCodegenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary [Dummy] Tool response type export for codegen
 */
export const prefetchGetV2DummyToolResponseTypeExportForCodegenQuery = async <
  TData = Awaited<
    ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>
  >,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DummyToolResponseTypeExportForCodegen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV2DummyToolResponseTypeExportForCodegenQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListSessionsResponse200 = {
  data: ListSessionsResponse;
  status: 200;
};

export type getV2ListSessionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListSessionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListSessionsResponseSuccess = getV2ListSessionsResponse200 & {
  headers: Headers;
};
export type getV2ListSessionsResponseError = (
  | getV2ListSessionsResponse401
  | getV2ListSessionsResponse422
) & {
  headers: Headers;
};

export type getV2ListSessionsResponse =
  | getV2ListSessionsResponseSuccess
  | getV2ListSessionsResponseError;

export const getGetV2ListSessionsUrl = (params?: GetV2ListSessionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/chat/sessions?${stringifiedParams}`
    : `/api/chat/sessions`;
};

/**
 * List chat sessions for the authenticated user.
 *
 * Returns a paginated list of chat sessions belonging to the current user,
 * with pinned sessions first and most-recently-updated as the tiebreaker.
 *
 * Args:
 *     user_id: The authenticated user's ID.
 *     limit: Maximum number of sessions to return (1-100).
 *     offset: Number of sessions to skip for pagination.
 *     expert_id: Restrict the listing to sessions scoped to this expert.
 *     pinned_first: Whether pinned sessions precede strict recency ordering.
 *
 * Returns:
 *     ListSessionsResponse: List of session summaries and total count.
 * @summary List Sessions
 */
export const getV2ListSessions = async (
  params?: GetV2ListSessionsParams,
  options?: RequestInit,
): Promise<getV2ListSessionsResponse> => {
  return customMutator<getV2ListSessionsResponse>(
    getGetV2ListSessionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListSessionsQueryKey = (
  params?: GetV2ListSessionsParams,
) => {
  return [`/api/chat/sessions`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListSessions>>
  > = ({ signal }) => getV2ListSessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListSessions>>
>;
export type GetV2ListSessionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListSessions<
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListSessionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListSessions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListSessions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListSessions<
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListSessions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListSessions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListSessions<
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Sessions
 */

export function useGetV2ListSessions<
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Sessions
 */
export const prefetchGetV2ListSessionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListSessions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListSessionsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CreateSessionResponse200 = {
  data: CreateSessionResponse;
  status: 200;
};

export type postV2CreateSessionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CreateSessionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CreateSessionResponseSuccess =
  postV2CreateSessionResponse200 & {
    headers: Headers;
  };
export type postV2CreateSessionResponseError = (
  | postV2CreateSessionResponse401
  | postV2CreateSessionResponse422
) & {
  headers: Headers;
};

export type postV2CreateSessionResponse =
  | postV2CreateSessionResponseSuccess
  | postV2CreateSessionResponseError;

export const getPostV2CreateSessionUrl = () => {
  return `/api/chat/sessions`;
};

/**
 * Create (or get-or-create) a chat session.
 *
 * Four modes, selected by the request body:
 *
 * - Default: create a fresh session for the user. ``dry_run=True`` forces
 *   run_capability and run_agent calls to use dry-run simulation.
 * - Builder-bound: when ``builder_graph_id`` is set, get-or-create keyed
 *   on ``(user_id, builder_graph_id)``. Returns the existing session for
 *   that graph or creates one locked to it.  Graph ownership is validated
 *   inside :func:`get_or_create_builder_session`; raises 404 on
 *   unauthorized access.  Write-side scope is enforced per-tool
 *   (``edit_agent`` / ``run_agent`` reject any ``agent_id`` other than
 *   the bound graph) and a small blacklist hides tools that conflict
 *   with the panel's scope (see :data:`BUILDER_BLOCKED_TOOLS`).
 * - Expert kickoff: atomically create or adopt the canonical first session
 *   for ``(user_id, expert_id)``.
 * - Client-named: when ``session_id`` is set, a plain or expert create
 *   adopts the session that id already names, so a retry after a lost
 *   response never leaves an empty session behind.
 *
 * Args:
 *     user_id: The authenticated user ID parsed from the JWT (required).
 *     request: Optional request body with ``dry_run``,
 *         ``builder_graph_id``, ``expert_id``, ``expert_kickoff`` and/or
 *         ``session_id``.
 *
 * Returns:
 *     CreateSessionResponse: Details of the resulting session.
 * @summary Create Session
 */
export const postV2CreateSession = async (
  createSessionRequestNull?: CreateSessionRequest | null,
  options?: RequestInit,
): Promise<postV2CreateSessionResponse> => {
  return customMutator<postV2CreateSessionResponse>(
    getPostV2CreateSessionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createSessionRequestNull),
    },
  );
};

export const getPostV2CreateSessionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CreateSession>>,
    TError,
    { data?: CreateSessionRequest | null },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CreateSession>>,
  TError,
  { data?: CreateSessionRequest | null },
  TContext
> => {
  const mutationKey = ["postV2CreateSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CreateSession>>,
    { data?: CreateSessionRequest | null }
  > = (props) => {
    const { data } = props ?? {};

    return postV2CreateSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CreateSession>>
>;
export type PostV2CreateSessionMutationBody =
  | CreateSessionRequest
  | null
  | undefined;
export type PostV2CreateSessionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create Session
 */
export const usePostV2CreateSession = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CreateSession>>,
      TError,
      { data?: CreateSessionRequest | null },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CreateSession>>,
  TError,
  { data?: CreateSessionRequest | null },
  TContext
> => {
  return useMutation(
    getPostV2CreateSessionMutationOptions(options),
    queryClient,
  );
};
export type deleteV2DeleteSessionResponse204 = {
  data: void;
  status: 204;
};

export type deleteV2DeleteSessionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2DeleteSessionResponse404 = {
  data: void;
  status: 404;
};

export type deleteV2DeleteSessionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2DeleteSessionResponseSuccess =
  deleteV2DeleteSessionResponse204 & {
    headers: Headers;
  };
export type deleteV2DeleteSessionResponseError = (
  | deleteV2DeleteSessionResponse401
  | deleteV2DeleteSessionResponse404
  | deleteV2DeleteSessionResponse422
) & {
  headers: Headers;
};

export type deleteV2DeleteSessionResponse =
  | deleteV2DeleteSessionResponseSuccess
  | deleteV2DeleteSessionResponseError;

export const getDeleteV2DeleteSessionUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}`;
};

/**
 * Delete a chat session.
 *
 * Permanently removes a chat session and all its messages.
 * Only the owner can delete their sessions.
 *
 * Args:
 *     session_id: The session ID to delete.
 *     user_id: The authenticated user's ID.
 *
 * Returns:
 *     204 No Content on success.
 *
 * Raises:
 *     HTTPException: 404 if session not found or not owned by user.
 * @summary Delete Session
 */
export const deleteV2DeleteSession = async (
  sessionId: string,
  options?: RequestInit,
): Promise<deleteV2DeleteSessionResponse> => {
  return customMutator<deleteV2DeleteSessionResponse>(
    getDeleteV2DeleteSessionUrl(sessionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2DeleteSessionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2DeleteSession>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2DeleteSession>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["deleteV2DeleteSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2DeleteSession>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return deleteV2DeleteSession(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2DeleteSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2DeleteSession>>
>;

export type DeleteV2DeleteSessionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Delete Session
 */
export const useDeleteV2DeleteSession = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2DeleteSession>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2DeleteSession>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getDeleteV2DeleteSessionMutationOptions(options),
    queryClient,
  );
};
export type getV2GetSessionResponse200 = {
  data: SessionDetailResponse;
  status: 200;
};

export type getV2GetSessionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetSessionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetSessionResponseSuccess = getV2GetSessionResponse200 & {
  headers: Headers;
};
export type getV2GetSessionResponseError = (
  | getV2GetSessionResponse401
  | getV2GetSessionResponse422
) & {
  headers: Headers;
};

export type getV2GetSessionResponse =
  | getV2GetSessionResponseSuccess
  | getV2GetSessionResponseError;

export const getGetV2GetSessionUrl = (
  sessionId: string,
  params?: GetV2GetSessionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/chat/sessions/${sessionId}?${stringifiedParams}`
    : `/api/chat/sessions/${sessionId}`;
};

/**
 * Retrieve the details of a specific chat session.
 *
 * Supports cursor-based pagination via ``limit`` and ``before_sequence``.
 * When no pagination params are provided, returns the most recent messages.
 * @summary Get Session
 */
export const getV2GetSession = async (
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: RequestInit,
): Promise<getV2GetSessionResponse> => {
  return customMutator<getV2GetSessionResponse>(
    getGetV2GetSessionUrl(sessionId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSessionQueryKey = (
  sessionId: string,
  params?: GetV2GetSessionParams,
) => {
  return [
    `/api/chat/sessions/${sessionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetSessionQueryKey(sessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2GetSession>>> = ({
    signal,
  }) => getV2GetSession(sessionId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSession>>
>;
export type GetV2GetSessionQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetSession<
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  params: undefined | GetV2GetSessionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSession>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSession>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSession<
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSession>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSession>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSession<
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Session
 */

export function useGetV2GetSession<
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSessionQueryOptions(
    sessionId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Session
 */
export const prefetchGetV2GetSessionQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSession>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  params?: GetV2GetSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSessionQueryOptions(
    sessionId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type patchV2SessionAssignUserResponse200 = {
  data: PatchV2SessionAssignUser200;
  status: 200;
};

export type patchV2SessionAssignUserResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV2SessionAssignUserResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV2SessionAssignUserResponseSuccess =
  patchV2SessionAssignUserResponse200 & {
    headers: Headers;
  };
export type patchV2SessionAssignUserResponseError = (
  | patchV2SessionAssignUserResponse401
  | patchV2SessionAssignUserResponse422
) & {
  headers: Headers;
};

export type patchV2SessionAssignUserResponse =
  | patchV2SessionAssignUserResponseSuccess
  | patchV2SessionAssignUserResponseError;

export const getPatchV2SessionAssignUserUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/assign-user`;
};

/**
 * Assign an authenticated user to a chat session.
 *
 * Used (typically post-login) to claim an existing anonymous session as the current authenticated user.
 *
 * Args:
 *     session_id: The identifier for the (previously anonymous) session.
 *     user_id: The authenticated user's ID to associate with the session.
 *
 * Returns:
 *     dict: Status of the assignment.
 * @summary Session Assign User
 */
export const patchV2SessionAssignUser = async (
  sessionId: string,
  options?: RequestInit,
): Promise<patchV2SessionAssignUserResponse> => {
  return customMutator<patchV2SessionAssignUserResponse>(
    getPatchV2SessionAssignUserUrl(sessionId),
    {
      ...options,
      method: "PATCH",
    },
  );
};

export const getPatchV2SessionAssignUserMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV2SessionAssignUser>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV2SessionAssignUser>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["patchV2SessionAssignUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV2SessionAssignUser>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return patchV2SessionAssignUser(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV2SessionAssignUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV2SessionAssignUser>>
>;

export type PatchV2SessionAssignUserMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Session Assign User
 */
export const usePatchV2SessionAssignUser = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV2SessionAssignUser>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV2SessionAssignUser>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getPatchV2SessionAssignUserMutationOptions(options),
    queryClient,
  );
};
export type getV2ListTurnsAtBudgetResetResponse200 = {
  data: AtResetTurnsResponse;
  status: 200;
};

export type getV2ListTurnsAtBudgetResetResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListTurnsAtBudgetResetResponse404 = {
  data: void;
  status: 404;
};

export type getV2ListTurnsAtBudgetResetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListTurnsAtBudgetResetResponseSuccess =
  getV2ListTurnsAtBudgetResetResponse200 & {
    headers: Headers;
  };
export type getV2ListTurnsAtBudgetResetResponseError = (
  | getV2ListTurnsAtBudgetResetResponse401
  | getV2ListTurnsAtBudgetResetResponse404
  | getV2ListTurnsAtBudgetResetResponse422
) & {
  headers: Headers;
};

export type getV2ListTurnsAtBudgetResetResponse =
  | getV2ListTurnsAtBudgetResetResponseSuccess
  | getV2ListTurnsAtBudgetResetResponseError;

export const getGetV2ListTurnsAtBudgetResetUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/at-reset`;
};

/**
 * The chat's pending resume and send at the budget reset.
 * @summary List turns at budget reset
 */
export const getV2ListTurnsAtBudgetReset = async (
  sessionId: string,
  options?: RequestInit,
): Promise<getV2ListTurnsAtBudgetResetResponse> => {
  return customMutator<getV2ListTurnsAtBudgetResetResponse>(
    getGetV2ListTurnsAtBudgetResetUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListTurnsAtBudgetResetQueryKey = (sessionId: string) => {
  return [`/api/chat/sessions/${sessionId}/at-reset`] as const;
};

export const getGetV2ListTurnsAtBudgetResetQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListTurnsAtBudgetResetQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>
  > = ({ signal }) =>
    getV2ListTurnsAtBudgetReset(sessionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListTurnsAtBudgetResetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>
>;
export type GetV2ListTurnsAtBudgetResetQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetV2ListTurnsAtBudgetReset<
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
          TError,
          Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListTurnsAtBudgetReset<
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
          TError,
          Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListTurnsAtBudgetReset<
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List turns at budget reset
 */

export function useGetV2ListTurnsAtBudgetReset<
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListTurnsAtBudgetResetQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List turns at budget reset
 */
export const prefetchGetV2ListTurnsAtBudgetResetQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListTurnsAtBudgetReset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListTurnsAtBudgetResetQueryOptions(
    sessionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2ScheduleTurnAtBudgetResetResponse200 = {
  data: AtResetTurn;
  status: 200;
};

export type postV2ScheduleTurnAtBudgetResetResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ScheduleTurnAtBudgetResetResponse404 = {
  data: void;
  status: 404;
};

export type postV2ScheduleTurnAtBudgetResetResponse409 = {
  data: void;
  status: 409;
};

export type postV2ScheduleTurnAtBudgetResetResponse413 = {
  data: void;
  status: 413;
};

export type postV2ScheduleTurnAtBudgetResetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ScheduleTurnAtBudgetResetResponse503 = {
  data: void;
  status: 503;
};

export type postV2ScheduleTurnAtBudgetResetResponseSuccess =
  postV2ScheduleTurnAtBudgetResetResponse200 & {
    headers: Headers;
  };
export type postV2ScheduleTurnAtBudgetResetResponseError = (
  | postV2ScheduleTurnAtBudgetResetResponse401
  | postV2ScheduleTurnAtBudgetResetResponse404
  | postV2ScheduleTurnAtBudgetResetResponse409
  | postV2ScheduleTurnAtBudgetResetResponse413
  | postV2ScheduleTurnAtBudgetResetResponse422
  | postV2ScheduleTurnAtBudgetResetResponse503
) & {
  headers: Headers;
};

export type postV2ScheduleTurnAtBudgetResetResponse =
  | postV2ScheduleTurnAtBudgetResetResponseSuccess
  | postV2ScheduleTurnAtBudgetResetResponseError;

export const getPostV2ScheduleTurnAtBudgetResetUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/at-reset`;
};

/**
 * Resume the chat's paused task, or send a message, when the budget resets.
 *
 * It fires just after the exhausted window that refills last. A chat has
 * at most one of each: a resume set again replaces the earlier one, and a
 * send joins the message already waiting, so nothing written meanwhile is
 * lost. Sending a message in the chat cancels a pending resume.
 * @summary Schedule turn at budget reset
 */
export const postV2ScheduleTurnAtBudgetReset = async (
  sessionId: string,
  atResetRequest: AtResetRequest,
  options?: RequestInit,
): Promise<postV2ScheduleTurnAtBudgetResetResponse> => {
  return customMutator<postV2ScheduleTurnAtBudgetResetResponse>(
    getPostV2ScheduleTurnAtBudgetResetUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(atResetRequest),
    },
  );
};

export const getPostV2ScheduleTurnAtBudgetResetMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>,
    TError,
    { sessionId: string; data: AtResetRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>,
  TError,
  { sessionId: string; data: AtResetRequest },
  TContext
> => {
  const mutationKey = ["postV2ScheduleTurnAtBudgetReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>,
    { sessionId: string; data: AtResetRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2ScheduleTurnAtBudgetReset(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ScheduleTurnAtBudgetResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>
>;
export type PostV2ScheduleTurnAtBudgetResetMutationBody = AtResetRequest;
export type PostV2ScheduleTurnAtBudgetResetMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Schedule turn at budget reset
 */
export const usePostV2ScheduleTurnAtBudgetReset = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>,
      TError,
      { sessionId: string; data: AtResetRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ScheduleTurnAtBudgetReset>>,
  TError,
  { sessionId: string; data: AtResetRequest },
  TContext
> => {
  return useMutation(
    getPostV2ScheduleTurnAtBudgetResetMutationOptions(options),
    queryClient,
  );
};
export type deleteV2CancelTurnAtBudgetResetResponse204 = {
  data: void;
  status: 204;
};

export type deleteV2CancelTurnAtBudgetResetResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2CancelTurnAtBudgetResetResponse404 = {
  data: void;
  status: 404;
};

export type deleteV2CancelTurnAtBudgetResetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2CancelTurnAtBudgetResetResponseSuccess =
  deleteV2CancelTurnAtBudgetResetResponse204 & {
    headers: Headers;
  };
export type deleteV2CancelTurnAtBudgetResetResponseError = (
  | deleteV2CancelTurnAtBudgetResetResponse401
  | deleteV2CancelTurnAtBudgetResetResponse404
  | deleteV2CancelTurnAtBudgetResetResponse422
) & {
  headers: Headers;
};

export type deleteV2CancelTurnAtBudgetResetResponse =
  | deleteV2CancelTurnAtBudgetResetResponseSuccess
  | deleteV2CancelTurnAtBudgetResetResponseError;

export const getDeleteV2CancelTurnAtBudgetResetUrl = (
  sessionId: string,
  kind: "resume" | "send",
) => {
  return `/api/chat/sessions/${sessionId}/at-reset/${kind}`;
};

/**
 * Cancel the chat's resume or send at the budget reset; one that isn't
 * set is already cancelled.
 * @summary Cancel turn at budget reset
 */
export const deleteV2CancelTurnAtBudgetReset = async (
  sessionId: string,
  kind: "resume" | "send",
  options?: RequestInit,
): Promise<deleteV2CancelTurnAtBudgetResetResponse> => {
  return customMutator<deleteV2CancelTurnAtBudgetResetResponse>(
    getDeleteV2CancelTurnAtBudgetResetUrl(sessionId, kind),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2CancelTurnAtBudgetResetMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>,
    TError,
    { sessionId: string; kind: "resume" | "send" },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>,
  TError,
  { sessionId: string; kind: "resume" | "send" },
  TContext
> => {
  const mutationKey = ["deleteV2CancelTurnAtBudgetReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>,
    { sessionId: string; kind: "resume" | "send" }
  > = (props) => {
    const { sessionId, kind } = props ?? {};

    return deleteV2CancelTurnAtBudgetReset(sessionId, kind, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2CancelTurnAtBudgetResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>
>;

export type DeleteV2CancelTurnAtBudgetResetMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Cancel turn at budget reset
 */
export const useDeleteV2CancelTurnAtBudgetReset = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>,
      TError,
      { sessionId: string; kind: "resume" | "send" },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2CancelTurnAtBudgetReset>>,
  TError,
  { sessionId: string; kind: "resume" | "send" },
  TContext
> => {
  return useMutation(
    getDeleteV2CancelTurnAtBudgetResetMutationOptions(options),
    queryClient,
  );
};
export type postV2CancelSessionTaskResponse200 = {
  data: CancelSessionResponse;
  status: 200;
};

export type postV2CancelSessionTaskResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CancelSessionTaskResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CancelSessionTaskResponseSuccess =
  postV2CancelSessionTaskResponse200 & {
    headers: Headers;
  };
export type postV2CancelSessionTaskResponseError = (
  | postV2CancelSessionTaskResponse401
  | postV2CancelSessionTaskResponse422
) & {
  headers: Headers;
};

export type postV2CancelSessionTaskResponse =
  | postV2CancelSessionTaskResponseSuccess
  | postV2CancelSessionTaskResponseError;

export const getPostV2CancelSessionTaskUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/cancel`;
};

/**
 * Cancel an in-flight task for a session.
 *
 * Handles both lifecycle states uniformly:
 *
 * * **Queued** (``chatStatus='queued'``) — the dispatcher hasn't
 *   claimed the row yet.  Flip the session back to ``idle`` and
 *   return; no executor cancel event needed.
 * * **Running** (``chatStatus='running'``) — publish a cancel event
 *   to the executor via RabbitMQ FANOUT, then poll Redis until the
 *   task status flips out of ``running`` or a 5 s timeout is hit.
 * @summary Cancel Session Task
 */
export const postV2CancelSessionTask = async (
  sessionId: string,
  options?: RequestInit,
): Promise<postV2CancelSessionTaskResponse> => {
  return customMutator<postV2CancelSessionTaskResponse>(
    getPostV2CancelSessionTaskUrl(sessionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2CancelSessionTaskMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CancelSessionTask>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CancelSessionTask>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["postV2CancelSessionTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CancelSessionTask>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return postV2CancelSessionTask(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CancelSessionTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CancelSessionTask>>
>;

export type PostV2CancelSessionTaskMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Cancel Session Task
 */
export const usePostV2CancelSessionTask = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CancelSessionTask>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CancelSessionTask>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getPostV2CancelSessionTaskMutationOptions(options),
    queryClient,
  );
};
export type getV2GetSessionComputerResponse200 = {
  data: ComputerInfo;
  status: 200;
};

export type getV2GetSessionComputerResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetSessionComputerResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetSessionComputerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetSessionComputerResponseSuccess =
  getV2GetSessionComputerResponse200 & {
    headers: Headers;
  };
export type getV2GetSessionComputerResponseError = (
  | getV2GetSessionComputerResponse401
  | getV2GetSessionComputerResponse404
  | getV2GetSessionComputerResponse422
) & {
  headers: Headers;
};

export type getV2GetSessionComputerResponse =
  | getV2GetSessionComputerResponseSuccess
  | getV2GetSessionComputerResponseError;

export const getGetV2GetSessionComputerUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/computer`;
};

/**
 * The computer behind this chat.
 *
 * A plain chat has its own box; a chat that runs as a hired expert reports
 * the expert's persistent computer instead. Listing never wakes a paused box.
 * @summary Get Session Computer
 */
export const getV2GetSessionComputer = async (
  sessionId: string,
  options?: RequestInit,
): Promise<getV2GetSessionComputerResponse> => {
  return customMutator<getV2GetSessionComputerResponse>(
    getGetV2GetSessionComputerUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSessionComputerQueryKey = (sessionId: string) => {
  return [`/api/chat/sessions/${sessionId}/computer`] as const;
};

export const getGetV2GetSessionComputerQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetSessionComputerQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetSessionComputer>>
  > = ({ signal }) =>
    getV2GetSessionComputer(sessionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSessionComputer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSessionComputerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSessionComputer>>
>;
export type GetV2GetSessionComputerQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetV2GetSessionComputer<
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSessionComputer>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSessionComputer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSessionComputer<
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSessionComputer>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSessionComputer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSessionComputer<
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Session Computer
 */

export function useGetV2GetSessionComputer<
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSessionComputerQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Session Computer
 */
export const prefetchGetV2GetSessionComputerQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSessionComputer>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSessionComputer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSessionComputerQueryOptions(
    sessionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponse200 = {
  data: PutV2ChangeTheConnectionAnExistingChatRunsOn200;
  status: 200;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponse404 = {
  data: void;
  status: 404;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponseSuccess =
  putV2ChangeTheConnectionAnExistingChatRunsOnResponse200 & {
    headers: Headers;
  };
export type putV2ChangeTheConnectionAnExistingChatRunsOnResponseError = (
  | putV2ChangeTheConnectionAnExistingChatRunsOnResponse401
  | putV2ChangeTheConnectionAnExistingChatRunsOnResponse404
  | putV2ChangeTheConnectionAnExistingChatRunsOnResponse422
) & {
  headers: Headers;
};

export type putV2ChangeTheConnectionAnExistingChatRunsOnResponse =
  | putV2ChangeTheConnectionAnExistingChatRunsOnResponseSuccess
  | putV2ChangeTheConnectionAnExistingChatRunsOnResponseError;

export const getPutV2ChangeTheConnectionAnExistingChatRunsOnUrl = (
  sessionId: string,
) => {
  return `/api/chat/sessions/${sessionId}/connection`;
};

/**
 * Move a chat onto another connection, from the next turn onward.
 *
 * A chat is latched to the connection it started on so that a turn cannot
 * silently change who pays for it halfway through. This is the deliberate
 * exception: when a provider stops accepting turns -- a spent quota, an
 * expired login -- the alternative to switching is the chat simply ending.
 *
 * It never happens on its own. The caller is a button the user pressed, and
 * the run continues on the connection they picked rather than on whichever
 * one happens to work.
 *
 * History is not rewritten. Turns already stamped keep the connection they
 * ran on, so a chat that hit a limit and carried on elsewhere reads as
 * exactly that.
 * @summary Change the connection an existing chat runs on
 */
export const putV2ChangeTheConnectionAnExistingChatRunsOn = async (
  sessionId: string,
  changeSessionConnectionRequest: ChangeSessionConnectionRequest,
  options?: RequestInit,
): Promise<putV2ChangeTheConnectionAnExistingChatRunsOnResponse> => {
  return customMutator<putV2ChangeTheConnectionAnExistingChatRunsOnResponse>(
    getPutV2ChangeTheConnectionAnExistingChatRunsOnUrl(sessionId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(changeSessionConnectionRequest),
    },
  );
};

export const getPutV2ChangeTheConnectionAnExistingChatRunsOnMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>,
    TError,
    { sessionId: string; data: ChangeSessionConnectionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>,
  TError,
  { sessionId: string; data: ChangeSessionConnectionRequest },
  TContext
> => {
  const mutationKey = ["putV2ChangeTheConnectionAnExistingChatRunsOn"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>,
    { sessionId: string; data: ChangeSessionConnectionRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return putV2ChangeTheConnectionAnExistingChatRunsOn(
      sessionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV2ChangeTheConnectionAnExistingChatRunsOnMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>
  >;
export type PutV2ChangeTheConnectionAnExistingChatRunsOnMutationBody =
  ChangeSessionConnectionRequest;
export type PutV2ChangeTheConnectionAnExistingChatRunsOnMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Change the connection an existing chat runs on
 */
export const usePutV2ChangeTheConnectionAnExistingChatRunsOn = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>,
      TError,
      { sessionId: string; data: ChangeSessionConnectionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV2ChangeTheConnectionAnExistingChatRunsOn>>,
  TError,
  { sessionId: string; data: ChangeSessionConnectionRequest },
  TContext
> => {
  return useMutation(
    getPutV2ChangeTheConnectionAnExistingChatRunsOnMutationOptions(options),
    queryClient,
  );
};
export type postV2ContinueSessionResponse202 = {
  data: ContinueSessionResponse;
  status: 202;
};

export type postV2ContinueSessionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ContinueSessionResponse402 = {
  data: void;
  status: 402;
};

export type postV2ContinueSessionResponse404 = {
  data: void;
  status: 404;
};

export type postV2ContinueSessionResponse409 = {
  data: void;
  status: 409;
};

export type postV2ContinueSessionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ContinueSessionResponse429 = {
  data: void;
  status: 429;
};

export type postV2ContinueSessionResponse503 = {
  data: void;
  status: 503;
};

export type postV2ContinueSessionResponseSuccess =
  postV2ContinueSessionResponse202 & {
    headers: Headers;
  };
export type postV2ContinueSessionResponseError = (
  | postV2ContinueSessionResponse401
  | postV2ContinueSessionResponse402
  | postV2ContinueSessionResponse404
  | postV2ContinueSessionResponse409
  | postV2ContinueSessionResponse422
  | postV2ContinueSessionResponse429
  | postV2ContinueSessionResponse503
) & {
  headers: Headers;
};

export type postV2ContinueSessionResponse =
  | postV2ContinueSessionResponseSuccess
  | postV2ContinueSessionResponseError;

export const getPostV2ContinueSessionUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/continue`;
};

/**
 * Continue the chat's task from the checkpoint it paused at.
 * @summary Continue Session
 */
export const postV2ContinueSession = async (
  sessionId: string,
  continueSessionRequestNull?: ContinueSessionRequest | null,
  options?: RequestInit,
): Promise<postV2ContinueSessionResponse> => {
  return customMutator<postV2ContinueSessionResponse>(
    getPostV2ContinueSessionUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(continueSessionRequestNull),
    },
  );
};

export const getPostV2ContinueSessionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ContinueSession>>,
    TError,
    { sessionId: string; data?: ContinueSessionRequest | null },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ContinueSession>>,
  TError,
  { sessionId: string; data?: ContinueSessionRequest | null },
  TContext
> => {
  const mutationKey = ["postV2ContinueSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ContinueSession>>,
    { sessionId: string; data?: ContinueSessionRequest | null }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2ContinueSession(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ContinueSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ContinueSession>>
>;
export type PostV2ContinueSessionMutationBody =
  | ContinueSessionRequest
  | null
  | undefined;
export type PostV2ContinueSessionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Continue Session
 */
export const usePostV2ContinueSession = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ContinueSession>>,
      TError,
      { sessionId: string; data?: ContinueSessionRequest | null },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ContinueSession>>,
  TError,
  { sessionId: string; data?: ContinueSessionRequest | null },
  TContext
> => {
  return useMutation(
    getPostV2ContinueSessionMutationOptions(options),
    queryClient,
  );
};
export type putV2RecordCredentialPicksForThisChatResponse200 = {
  data: PutV2RecordCredentialPicksForThisChat200;
  status: 200;
};

export type putV2RecordCredentialPicksForThisChatResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV2RecordCredentialPicksForThisChatResponse404 = {
  data: void;
  status: 404;
};

export type putV2RecordCredentialPicksForThisChatResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV2RecordCredentialPicksForThisChatResponseSuccess =
  putV2RecordCredentialPicksForThisChatResponse200 & {
    headers: Headers;
  };
export type putV2RecordCredentialPicksForThisChatResponseError = (
  | putV2RecordCredentialPicksForThisChatResponse401
  | putV2RecordCredentialPicksForThisChatResponse404
  | putV2RecordCredentialPicksForThisChatResponse422
) & {
  headers: Headers;
};

export type putV2RecordCredentialPicksForThisChatResponse =
  | putV2RecordCredentialPicksForThisChatResponseSuccess
  | putV2RecordCredentialPicksForThisChatResponseError;

export const getPutV2RecordCredentialPicksForThisChatUrl = (
  sessionId: string,
) => {
  return `/api/chat/sessions/${sessionId}/credential-selection`;
};

/**
 * Keep the account the user chose on a connect card for the rest of the chat.
 *
 * The card shows one account and the tools used to re-match on their own, so
 * with two accounts for a provider a run could land on the other one. The
 * tools now use exactly what is recorded here, and ask when several
 * credentials qualify and nothing was picked.
 *
 * Every id is checked against the caller's own credentials and the provider
 * it is filed under; one bad entry rejects the request and records nothing.
 * @summary Record credential picks for this chat
 */
export const putV2RecordCredentialPicksForThisChat = async (
  sessionId: string,
  credentialSelectionRequest: CredentialSelectionRequest,
  options?: RequestInit,
): Promise<putV2RecordCredentialPicksForThisChatResponse> => {
  return customMutator<putV2RecordCredentialPicksForThisChatResponse>(
    getPutV2RecordCredentialPicksForThisChatUrl(sessionId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(credentialSelectionRequest),
    },
  );
};

export const getPutV2RecordCredentialPicksForThisChatMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>,
    TError,
    { sessionId: string; data: CredentialSelectionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>,
  TError,
  { sessionId: string; data: CredentialSelectionRequest },
  TContext
> => {
  const mutationKey = ["putV2RecordCredentialPicksForThisChat"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>,
    { sessionId: string; data: CredentialSelectionRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return putV2RecordCredentialPicksForThisChat(
      sessionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV2RecordCredentialPicksForThisChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>
>;
export type PutV2RecordCredentialPicksForThisChatMutationBody =
  CredentialSelectionRequest;
export type PutV2RecordCredentialPicksForThisChatMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Record credential picks for this chat
 */
export const usePutV2RecordCredentialPicksForThisChat = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>,
      TError,
      { sessionId: string; data: CredentialSelectionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV2RecordCredentialPicksForThisChat>>,
  TError,
  { sessionId: string; data: CredentialSelectionRequest },
  TContext
> => {
  return useMutation(
    getPutV2RecordCredentialPicksForThisChatMutationOptions(options),
    queryClient,
  );
};
export type postV2StartSessionDesktopResponse200 = {
  data: DesktopStream;
  status: 200;
};

export type postV2StartSessionDesktopResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StartSessionDesktopResponse404 = {
  data: void;
  status: 404;
};

export type postV2StartSessionDesktopResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StartSessionDesktopResponse502 = {
  data: void;
  status: 502;
};

export type postV2StartSessionDesktopResponse503 = {
  data: void;
  status: 503;
};

export type postV2StartSessionDesktopResponseSuccess =
  postV2StartSessionDesktopResponse200 & {
    headers: Headers;
  };
export type postV2StartSessionDesktopResponseError = (
  | postV2StartSessionDesktopResponse401
  | postV2StartSessionDesktopResponse404
  | postV2StartSessionDesktopResponse422
  | postV2StartSessionDesktopResponse502
  | postV2StartSessionDesktopResponse503
) & {
  headers: Headers;
};

export type postV2StartSessionDesktopResponse =
  | postV2StartSessionDesktopResponseSuccess
  | postV2StartSessionDesktopResponseError;

export const getPostV2StartSessionDesktopUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/desktop`;
};

/**
 * Start or resume the desktop behind this chat and return its live stream.
 *
 * Same box the ``start_desktop`` tool uses from inside a turn, so the side
 * panel and the model always look at one screen.
 * @summary Start Session Desktop
 */
export const postV2StartSessionDesktop = async (
  sessionId: string,
  options?: RequestInit,
): Promise<postV2StartSessionDesktopResponse> => {
  return customMutator<postV2StartSessionDesktopResponse>(
    getPostV2StartSessionDesktopUrl(sessionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2StartSessionDesktopMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StartSessionDesktop>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StartSessionDesktop>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["postV2StartSessionDesktop"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StartSessionDesktop>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return postV2StartSessionDesktop(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StartSessionDesktopMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StartSessionDesktop>>
>;

export type PostV2StartSessionDesktopMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Start Session Desktop
 */
export const usePostV2StartSessionDesktop = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StartSessionDesktop>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StartSessionDesktop>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getPostV2StartSessionDesktopMutationOptions(options),
    queryClient,
  );
};
export type postV2SubmitMessageFeedbackResponse200 = {
  data: MessageFeedbackResponse;
  status: 200;
};

export type postV2SubmitMessageFeedbackResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2SubmitMessageFeedbackResponse404 = {
  data: void;
  status: 404;
};

export type postV2SubmitMessageFeedbackResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2SubmitMessageFeedbackResponseSuccess =
  postV2SubmitMessageFeedbackResponse200 & {
    headers: Headers;
  };
export type postV2SubmitMessageFeedbackResponseError = (
  | postV2SubmitMessageFeedbackResponse401
  | postV2SubmitMessageFeedbackResponse404
  | postV2SubmitMessageFeedbackResponse422
) & {
  headers: Headers;
};

export type postV2SubmitMessageFeedbackResponse =
  | postV2SubmitMessageFeedbackResponseSuccess
  | postV2SubmitMessageFeedbackResponseError;

export const getPostV2SubmitMessageFeedbackUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/feedback`;
};

/**
 * Rate a reply in one of the caller's chats.
 *
 * Saves the rating, one per reply and score name so rating again
 * overwrites it, and sends it to PostHog LLM analytics as an
 * ``$ai_metric`` event. PostHog being down does not fail the request.
 * @summary Submit message feedback
 */
export const postV2SubmitMessageFeedback = async (
  sessionId: string,
  messageFeedbackRequest: MessageFeedbackRequest,
  options?: RequestInit,
): Promise<postV2SubmitMessageFeedbackResponse> => {
  return customMutator<postV2SubmitMessageFeedbackResponse>(
    getPostV2SubmitMessageFeedbackUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(messageFeedbackRequest),
    },
  );
};

export const getPostV2SubmitMessageFeedbackMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>,
    TError,
    { sessionId: string; data: MessageFeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>,
  TError,
  { sessionId: string; data: MessageFeedbackRequest },
  TContext
> => {
  const mutationKey = ["postV2SubmitMessageFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>,
    { sessionId: string; data: MessageFeedbackRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2SubmitMessageFeedback(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2SubmitMessageFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>
>;
export type PostV2SubmitMessageFeedbackMutationBody = MessageFeedbackRequest;
export type PostV2SubmitMessageFeedbackMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Submit message feedback
 */
export const usePostV2SubmitMessageFeedback = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>,
      TError,
      { sessionId: string; data: MessageFeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2SubmitMessageFeedback>>,
  TError,
  { sessionId: string; data: MessageFeedbackRequest },
  TContext
> => {
  return useMutation(
    getPostV2SubmitMessageFeedbackMutationOptions(options),
    queryClient,
  );
};
export type getV2GetPendingMessagesResponse200 = {
  data: PeekPendingMessagesResponse;
  status: 200;
};

export type getV2GetPendingMessagesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetPendingMessagesResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetPendingMessagesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetPendingMessagesResponseSuccess =
  getV2GetPendingMessagesResponse200 & {
    headers: Headers;
  };
export type getV2GetPendingMessagesResponseError = (
  | getV2GetPendingMessagesResponse401
  | getV2GetPendingMessagesResponse404
  | getV2GetPendingMessagesResponse422
) & {
  headers: Headers;
};

export type getV2GetPendingMessagesResponse =
  | getV2GetPendingMessagesResponseSuccess
  | getV2GetPendingMessagesResponseError;

export const getGetV2GetPendingMessagesUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/messages/pending`;
};

/**
 * Peek at the pending-message buffer without consuming it.
 *
 * Returns the current contents of the session's pending message buffer
 * so the frontend can restore the queued-message indicator after a page
 * refresh and clear it correctly once a turn drains the buffer.
 * @summary Get Pending Messages
 */
export const getV2GetPendingMessages = async (
  sessionId: string,
  options?: RequestInit,
): Promise<getV2GetPendingMessagesResponse> => {
  return customMutator<getV2GetPendingMessagesResponse>(
    getGetV2GetPendingMessagesUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetPendingMessagesQueryKey = (sessionId: string) => {
  return [`/api/chat/sessions/${sessionId}/messages/pending`] as const;
};

export const getGetV2GetPendingMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetPendingMessagesQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetPendingMessages>>
  > = ({ signal }) =>
    getV2GetPendingMessages(sessionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetPendingMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetPendingMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetPendingMessages>>
>;
export type GetV2GetPendingMessagesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

export function useGetV2GetPendingMessages<
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPendingMessages>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPendingMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPendingMessages<
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetPendingMessages>>,
          TError,
          Awaited<ReturnType<typeof getV2GetPendingMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetPendingMessages<
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Pending Messages
 */

export function useGetV2GetPendingMessages<
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetPendingMessagesQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Pending Messages
 */
export const prefetchGetV2GetPendingMessagesQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetPendingMessages>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetPendingMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetPendingMessagesQueryOptions(
    sessionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2QueuePendingMessageResponse200 = {
  data: QueuePendingMessageResponse;
  status: 200;
};

export type postV2QueuePendingMessageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2QueuePendingMessageResponse404 = {
  data: void;
  status: 404;
};

export type postV2QueuePendingMessageResponse409 = {
  data: void;
  status: 409;
};

export type postV2QueuePendingMessageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2QueuePendingMessageResponse429 = {
  data: void;
  status: 429;
};

export type postV2QueuePendingMessageResponse503 = {
  data: void;
  status: 503;
};

export type postV2QueuePendingMessageResponseSuccess =
  postV2QueuePendingMessageResponse200 & {
    headers: Headers;
  };
export type postV2QueuePendingMessageResponseError = (
  | postV2QueuePendingMessageResponse401
  | postV2QueuePendingMessageResponse404
  | postV2QueuePendingMessageResponse409
  | postV2QueuePendingMessageResponse422
  | postV2QueuePendingMessageResponse429
  | postV2QueuePendingMessageResponse503
) & {
  headers: Headers;
};

export type postV2QueuePendingMessageResponse =
  | postV2QueuePendingMessageResponseSuccess
  | postV2QueuePendingMessageResponseError;

export const getPostV2QueuePendingMessageUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/messages/pending`;
};

/**
 * Queue a follow-up message while the session has an active turn.
 * @summary Queue Pending Message
 */
export const postV2QueuePendingMessage = async (
  sessionId: string,
  queuePendingMessageRequest: QueuePendingMessageRequest,
  options?: RequestInit,
): Promise<postV2QueuePendingMessageResponse> => {
  return customMutator<postV2QueuePendingMessageResponse>(
    getPostV2QueuePendingMessageUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(queuePendingMessageRequest),
    },
  );
};

export const getPostV2QueuePendingMessageMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2QueuePendingMessage>>,
    TError,
    { sessionId: string; data: QueuePendingMessageRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2QueuePendingMessage>>,
  TError,
  { sessionId: string; data: QueuePendingMessageRequest },
  TContext
> => {
  const mutationKey = ["postV2QueuePendingMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2QueuePendingMessage>>,
    { sessionId: string; data: QueuePendingMessageRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2QueuePendingMessage(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2QueuePendingMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2QueuePendingMessage>>
>;
export type PostV2QueuePendingMessageMutationBody = QueuePendingMessageRequest;
export type PostV2QueuePendingMessageMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Queue Pending Message
 */
export const usePostV2QueuePendingMessage = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2QueuePendingMessage>>,
      TError,
      { sessionId: string; data: QueuePendingMessageRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2QueuePendingMessage>>,
  TError,
  { sessionId: string; data: QueuePendingMessageRequest },
  TContext
> => {
  return useMutation(
    getPostV2QueuePendingMessageMutationOptions(options),
    queryClient,
  );
};
export type patchV2UpdateSessionPinnedResponse200 = {
  data: PatchV2UpdateSessionPinned200;
  status: 200;
};

export type patchV2UpdateSessionPinnedResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV2UpdateSessionPinnedResponse404 = {
  data: void;
  status: 404;
};

export type patchV2UpdateSessionPinnedResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV2UpdateSessionPinnedResponseSuccess =
  patchV2UpdateSessionPinnedResponse200 & {
    headers: Headers;
  };
export type patchV2UpdateSessionPinnedResponseError = (
  | patchV2UpdateSessionPinnedResponse401
  | patchV2UpdateSessionPinnedResponse404
  | patchV2UpdateSessionPinnedResponse422
) & {
  headers: Headers;
};

export type patchV2UpdateSessionPinnedResponse =
  | patchV2UpdateSessionPinnedResponseSuccess
  | patchV2UpdateSessionPinnedResponseError;

export const getPatchV2UpdateSessionPinnedUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/pinned`;
};

/**
 * Pin or unpin a chat session.
 *
 * Pinned sessions surface at the top of the user's sidebar list ahead of
 * unpinned ones, regardless of recency.
 *
 * Args:
 *     session_id: The session ID to update.
 *     request: Request body containing the new pin state.
 *     user_id: The authenticated user's ID.
 *
 * Returns:
 *     dict: Status of the update.
 *
 * Raises:
 *     HTTPException: 404 if session not found or not owned by user.
 * @summary Update session pinned
 */
export const patchV2UpdateSessionPinned = async (
  sessionId: string,
  updateSessionPinnedRequest: UpdateSessionPinnedRequest,
  options?: RequestInit,
): Promise<patchV2UpdateSessionPinnedResponse> => {
  return customMutator<patchV2UpdateSessionPinnedResponse>(
    getPatchV2UpdateSessionPinnedUrl(sessionId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateSessionPinnedRequest),
    },
  );
};

export const getPatchV2UpdateSessionPinnedMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>,
    TError,
    { sessionId: string; data: UpdateSessionPinnedRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>,
  TError,
  { sessionId: string; data: UpdateSessionPinnedRequest },
  TContext
> => {
  const mutationKey = ["patchV2UpdateSessionPinned"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>,
    { sessionId: string; data: UpdateSessionPinnedRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return patchV2UpdateSessionPinned(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV2UpdateSessionPinnedMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>
>;
export type PatchV2UpdateSessionPinnedMutationBody = UpdateSessionPinnedRequest;
export type PatchV2UpdateSessionPinnedMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update session pinned
 */
export const usePatchV2UpdateSessionPinned = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>,
      TError,
      { sessionId: string; data: UpdateSessionPinnedRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV2UpdateSessionPinned>>,
  TError,
  { sessionId: string; data: UpdateSessionPinnedRequest },
  TContext
> => {
  return useMutation(
    getPatchV2UpdateSessionPinnedMutationOptions(options),
    queryClient,
  );
};
export type deleteV2DisableChatSharingResponse204 = {
  data: void;
  status: 204;
};

export type deleteV2DisableChatSharingResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2DisableChatSharingResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2DisableChatSharingResponseSuccess =
  deleteV2DisableChatSharingResponse204 & {
    headers: Headers;
  };
export type deleteV2DisableChatSharingResponseError = (
  | deleteV2DisableChatSharingResponse401
  | deleteV2DisableChatSharingResponse422
) & {
  headers: Headers;
};

export type deleteV2DisableChatSharingResponse =
  | deleteV2DisableChatSharingResponseSuccess
  | deleteV2DisableChatSharingResponseError;

export const getDeleteV2DisableChatSharingUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/share`;
};

/**
 * Revoke sharing for a chat session.
 *
 * Cascade-revokes linked executions whose share originated here
 * (``sharedVia == CHAT_LINK``).  User-initiated execution shares
 * survive — see :func:`backend.copilot.sharing.db.disable_chat_session_share`.
 * @summary Disable Chat Sharing
 */
export const deleteV2DisableChatSharing = async (
  sessionId: string,
  options?: RequestInit,
): Promise<deleteV2DisableChatSharingResponse> => {
  return customMutator<deleteV2DisableChatSharingResponse>(
    getDeleteV2DisableChatSharingUrl(sessionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2DisableChatSharingMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2DisableChatSharing>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2DisableChatSharing>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["deleteV2DisableChatSharing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2DisableChatSharing>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return deleteV2DisableChatSharing(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2DisableChatSharingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2DisableChatSharing>>
>;

export type DeleteV2DisableChatSharingMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Disable Chat Sharing
 */
export const useDeleteV2DisableChatSharing = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2DisableChatSharing>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2DisableChatSharing>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getDeleteV2DisableChatSharingMutationOptions(options),
    queryClient,
  );
};
export type postV2EnableChatSharingResponse200 = {
  data: ChatShareResponse;
  status: 200;
};

export type postV2EnableChatSharingResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2EnableChatSharingResponse404 = {
  data: void;
  status: 404;
};

export type postV2EnableChatSharingResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2EnableChatSharingResponseSuccess =
  postV2EnableChatSharingResponse200 & {
    headers: Headers;
  };
export type postV2EnableChatSharingResponseError = (
  | postV2EnableChatSharingResponse401
  | postV2EnableChatSharingResponse404
  | postV2EnableChatSharingResponse422
) & {
  headers: Headers;
};

export type postV2EnableChatSharingResponse =
  | postV2EnableChatSharingResponseSuccess
  | postV2EnableChatSharingResponseError;

export const getPostV2EnableChatSharingUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/share`;
};

/**
 * Enable sharing for a chat session.
 * @summary Enable Chat Sharing
 */
export const postV2EnableChatSharing = async (
  sessionId: string,
  enableShareRequest?: EnableShareRequest,
  options?: RequestInit,
): Promise<postV2EnableChatSharingResponse> => {
  return customMutator<postV2EnableChatSharingResponse>(
    getPostV2EnableChatSharingUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(enableShareRequest),
    },
  );
};

export const getPostV2EnableChatSharingMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2EnableChatSharing>>,
    TError,
    { sessionId: string; data?: EnableShareRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2EnableChatSharing>>,
  TError,
  { sessionId: string; data?: EnableShareRequest },
  TContext
> => {
  const mutationKey = ["postV2EnableChatSharing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2EnableChatSharing>>,
    { sessionId: string; data?: EnableShareRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2EnableChatSharing(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2EnableChatSharingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2EnableChatSharing>>
>;
export type PostV2EnableChatSharingMutationBody =
  | EnableShareRequest
  | undefined;
export type PostV2EnableChatSharingMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Enable Chat Sharing
 */
export const usePostV2EnableChatSharing = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2EnableChatSharing>>,
      TError,
      { sessionId: string; data?: EnableShareRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2EnableChatSharing>>,
  TError,
  { sessionId: string; data?: EnableShareRequest },
  TContext
> => {
  return useMutation(
    getPostV2EnableChatSharingMutationOptions(options),
    queryClient,
  );
};
export type getV2GetChatShareStateResponse200 = {
  data: ChatShareStateResponse;
  status: 200;
};

export type getV2GetChatShareStateResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetChatShareStateResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetChatShareStateResponseSuccess =
  getV2GetChatShareStateResponse200 & {
    headers: Headers;
  };
export type getV2GetChatShareStateResponseError = (
  | getV2GetChatShareStateResponse401
  | getV2GetChatShareStateResponse422
) & {
  headers: Headers;
};

export type getV2GetChatShareStateResponse =
  | getV2GetChatShareStateResponseSuccess
  | getV2GetChatShareStateResponseError;

export const getGetV2GetChatShareStateUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/share/state`;
};

/**
 * Return the chat's current share state.
 *
 * The share modal calls this on open so it can render in the right
 * mode (share-vs-revoke) and pre-select the auto-share toggle.
 * @summary Get Chat Share State
 */
export const getV2GetChatShareState = async (
  sessionId: string,
  options?: RequestInit,
): Promise<getV2GetChatShareStateResponse> => {
  return customMutator<getV2GetChatShareStateResponse>(
    getGetV2GetChatShareStateUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetChatShareStateQueryKey = (sessionId: string) => {
  return [`/api/chat/sessions/${sessionId}/share/state`] as const;
};

export const getGetV2GetChatShareStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetChatShareStateQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetChatShareState>>
  > = ({ signal }) =>
    getV2GetChatShareState(sessionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetChatShareState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetChatShareStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetChatShareState>>
>;
export type GetV2GetChatShareStateQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetChatShareState<
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetChatShareState>>,
          TError,
          Awaited<ReturnType<typeof getV2GetChatShareState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetChatShareState<
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetChatShareState>>,
          TError,
          Awaited<ReturnType<typeof getV2GetChatShareState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetChatShareState<
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Chat Share State
 */

export function useGetV2GetChatShareState<
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetChatShareStateQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Chat Share State
 */
export const prefetchGetV2GetChatShareStateQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetChatShareState>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetChatShareState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetChatShareStateQueryOptions(
    sessionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type deleteV2DisconnectSessionStreamResponse204 = {
  data: void;
  status: 204;
};

export type deleteV2DisconnectSessionStreamResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2DisconnectSessionStreamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2DisconnectSessionStreamResponseSuccess =
  deleteV2DisconnectSessionStreamResponse204 & {
    headers: Headers;
  };
export type deleteV2DisconnectSessionStreamResponseError = (
  | deleteV2DisconnectSessionStreamResponse401
  | deleteV2DisconnectSessionStreamResponse422
) & {
  headers: Headers;
};

export type deleteV2DisconnectSessionStreamResponse =
  | deleteV2DisconnectSessionStreamResponseSuccess
  | deleteV2DisconnectSessionStreamResponseError;

export const getDeleteV2DisconnectSessionStreamUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/stream`;
};

/**
 * Disconnect all active SSE listeners for a session.
 *
 * Called by the frontend when the user switches away from a chat so the
 * backend releases XREAD listeners immediately rather than waiting for
 * the 5-10 s timeout.
 * @summary Disconnect Session Stream
 */
export const deleteV2DisconnectSessionStream = async (
  sessionId: string,
  options?: RequestInit,
): Promise<deleteV2DisconnectSessionStreamResponse> => {
  return customMutator<deleteV2DisconnectSessionStreamResponse>(
    getDeleteV2DisconnectSessionStreamUrl(sessionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2DisconnectSessionStreamMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>,
    TError,
    { sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationKey = ["deleteV2DisconnectSessionStream"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return deleteV2DisconnectSessionStream(sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2DisconnectSessionStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>
>;

export type DeleteV2DisconnectSessionStreamMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Disconnect Session Stream
 */
export const useDeleteV2DisconnectSessionStream = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>,
      TError,
      { sessionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2DisconnectSessionStream>>,
  TError,
  { sessionId: string },
  TContext
> => {
  return useMutation(
    getDeleteV2DisconnectSessionStreamMutationOptions(options),
    queryClient,
  );
};
export type getV2ResumeSessionStreamResponse200 = {
  data: unknown;
  status: 200;
};

export type getV2ResumeSessionStreamResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ResumeSessionStreamResponse409 = {
  data: StreamResumeRefusal;
  status: 409;
};

export type getV2ResumeSessionStreamResponse410 = {
  data: StreamResumeRefusal;
  status: 410;
};

export type getV2ResumeSessionStreamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ResumeSessionStreamResponseSuccess =
  getV2ResumeSessionStreamResponse200 & {
    headers: Headers;
  };
export type getV2ResumeSessionStreamResponseError = (
  | getV2ResumeSessionStreamResponse401
  | getV2ResumeSessionStreamResponse409
  | getV2ResumeSessionStreamResponse410
  | getV2ResumeSessionStreamResponse422
) & {
  headers: Headers;
};

export type getV2ResumeSessionStreamResponse =
  | getV2ResumeSessionStreamResponseSuccess
  | getV2ResumeSessionStreamResponseError;

export const getGetV2ResumeSessionStreamUrl = (
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/chat/sessions/${sessionId}/stream?${stringifiedParams}`
    : `/api/chat/sessions/${sessionId}/stream`;
};

/**
 * Resume a session's stream.
 *
 * With ``turn``, serves exactly that turn's stored entries after ``after``
 * (``0-0`` for all of them) and then its live ones: 409 when entries after
 * the cursor were trimmed, 410 when the stream is gone. Every entry frame
 * carries ``id: <turn>:<entry>``.
 *
 * Without ``turn``, replays the active turn from ``0-0``, or returns 204
 * when nothing is running: the AI SDK's parser cannot continue a block it
 * did not see start.
 * @summary Resume Session Stream
 */
export const getV2ResumeSessionStream = async (
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: RequestInit,
): Promise<getV2ResumeSessionStreamResponse> => {
  return customMutator<getV2ResumeSessionStreamResponse>(
    getGetV2ResumeSessionStreamUrl(sessionId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ResumeSessionStreamQueryKey = (
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
) => {
  return [
    `/api/chat/sessions/${sessionId}/stream`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ResumeSessionStreamQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ResumeSessionStreamQueryKey(sessionId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ResumeSessionStream>>
  > = ({ signal }) =>
    getV2ResumeSessionStream(sessionId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ResumeSessionStreamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ResumeSessionStream>>
>;
export type GetV2ResumeSessionStreamQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | StreamResumeRefusal
  | HTTPValidationError;

export function useGetV2ResumeSessionStream<
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  sessionId: string,
  params: undefined | GetV2ResumeSessionStreamParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
          TError,
          Awaited<ReturnType<typeof getV2ResumeSessionStream>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ResumeSessionStream<
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
          TError,
          Awaited<ReturnType<typeof getV2ResumeSessionStream>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ResumeSessionStream<
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Resume Session Stream
 */

export function useGetV2ResumeSessionStream<
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ResumeSessionStreamQueryOptions(
    sessionId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Resume Session Stream
 */
export const prefetchGetV2ResumeSessionStreamQuery = async <
  TData = Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
  TError =
    | HTTP401NotAuthenticatedErrorResponse
    | StreamResumeRefusal
    | HTTPValidationError,
>(
  queryClient: QueryClient,
  sessionId: string,
  params?: GetV2ResumeSessionStreamParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ResumeSessionStream>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ResumeSessionStreamQueryOptions(
    sessionId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2StreamChatPostResponse200 = {
  data: unknown;
  status: 200;
};

export type postV2StreamChatPostResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StreamChatPostResponse402 = {
  data: void;
  status: 402;
};

export type postV2StreamChatPostResponse404 = {
  data: void;
  status: 404;
};

export type postV2StreamChatPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StreamChatPostResponse429 = {
  data: void;
  status: 429;
};

export type postV2StreamChatPostResponse503 = {
  data: void;
  status: 503;
};

export type postV2StreamChatPostResponseSuccess =
  postV2StreamChatPostResponse200 & {
    headers: Headers;
  };
export type postV2StreamChatPostResponseError = (
  | postV2StreamChatPostResponse401
  | postV2StreamChatPostResponse402
  | postV2StreamChatPostResponse404
  | postV2StreamChatPostResponse422
  | postV2StreamChatPostResponse429
  | postV2StreamChatPostResponse503
) & {
  headers: Headers;
};

export type postV2StreamChatPostResponse =
  | postV2StreamChatPostResponseSuccess
  | postV2StreamChatPostResponseError;

export const getPostV2StreamChatPostUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/stream`;
};

/**
 * Start a new turn and return an AI SDK UI message stream.
 *
 * Returns an SSE stream (``text/event-stream``) with Vercel AI SDK chunks
 * (text fragments, tool-call UI, tool results). The generation runs in a
 * background task that survives client disconnects; reconnect via
 * ``GET /sessions/{session_id}/stream`` to resume.
 *
 * Follow-up messages typed while a turn is already running should use
 * ``POST /sessions/{session_id}/messages/pending``. If an older client still
 * posts that follow-up here, we queue it defensively but still return a valid
 * empty UI-message stream so AI SDK transports never receive a JSON body from
 * the stream endpoint.
 *
 * Args:
 *     session_id: The chat session identifier.
 *     request: Request body with message, is_user_message, and optional context.
 *     user_id: Authenticated user ID.
 * @summary Stream Chat Post
 */
export const postV2StreamChatPost = async (
  sessionId: string,
  streamChatRequest: StreamChatRequest,
  options?: RequestInit,
): Promise<postV2StreamChatPostResponse> => {
  return customMutator<postV2StreamChatPostResponse>(
    getPostV2StreamChatPostUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(streamChatRequest),
    },
  );
};

export const getPostV2StreamChatPostMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StreamChatPost>>,
    TError,
    { sessionId: string; data: StreamChatRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StreamChatPost>>,
  TError,
  { sessionId: string; data: StreamChatRequest },
  TContext
> => {
  const mutationKey = ["postV2StreamChatPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StreamChatPost>>,
    { sessionId: string; data: StreamChatRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return postV2StreamChatPost(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StreamChatPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StreamChatPost>>
>;
export type PostV2StreamChatPostMutationBody = StreamChatRequest;
export type PostV2StreamChatPostMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Stream Chat Post
 */
export const usePostV2StreamChatPost = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StreamChatPost>>,
      TError,
      { sessionId: string; data: StreamChatRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StreamChatPost>>,
  TError,
  { sessionId: string; data: StreamChatRequest },
  TContext
> => {
  return useMutation(
    getPostV2StreamChatPostMutationOptions(options),
    queryClient,
  );
};
export type patchV2UpdateSessionTitleResponse200 = {
  data: PatchV2UpdateSessionTitle200;
  status: 200;
};

export type patchV2UpdateSessionTitleResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV2UpdateSessionTitleResponse404 = {
  data: void;
  status: 404;
};

export type patchV2UpdateSessionTitleResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV2UpdateSessionTitleResponseSuccess =
  patchV2UpdateSessionTitleResponse200 & {
    headers: Headers;
  };
export type patchV2UpdateSessionTitleResponseError = (
  | patchV2UpdateSessionTitleResponse401
  | patchV2UpdateSessionTitleResponse404
  | patchV2UpdateSessionTitleResponse422
) & {
  headers: Headers;
};

export type patchV2UpdateSessionTitleResponse =
  | patchV2UpdateSessionTitleResponseSuccess
  | patchV2UpdateSessionTitleResponseError;

export const getPatchV2UpdateSessionTitleUrl = (sessionId: string) => {
  return `/api/chat/sessions/${sessionId}/title`;
};

/**
 * Update the title of a chat session.
 *
 * Allows the user to rename their chat session.
 *
 * Args:
 *     session_id: The session ID to update.
 *     request: Request body containing the new title.
 *     user_id: The authenticated user's ID.
 *
 * Returns:
 *     dict: Status of the update.
 *
 * Raises:
 *     HTTPException: 404 if session not found or not owned by user.
 * @summary Update session title
 */
export const patchV2UpdateSessionTitle = async (
  sessionId: string,
  updateSessionTitleRequest: UpdateSessionTitleRequest,
  options?: RequestInit,
): Promise<patchV2UpdateSessionTitleResponse> => {
  return customMutator<patchV2UpdateSessionTitleResponse>(
    getPatchV2UpdateSessionTitleUrl(sessionId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateSessionTitleRequest),
    },
  );
};

export const getPatchV2UpdateSessionTitleMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>,
    TError,
    { sessionId: string; data: UpdateSessionTitleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>,
  TError,
  { sessionId: string; data: UpdateSessionTitleRequest },
  TContext
> => {
  const mutationKey = ["patchV2UpdateSessionTitle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>,
    { sessionId: string; data: UpdateSessionTitleRequest }
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return patchV2UpdateSessionTitle(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV2UpdateSessionTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>
>;
export type PatchV2UpdateSessionTitleMutationBody = UpdateSessionTitleRequest;
export type PatchV2UpdateSessionTitleMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Update session title
 */
export const usePatchV2UpdateSessionTitle = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>,
      TError,
      { sessionId: string; data: UpdateSessionTitleRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV2UpdateSessionTitle>>,
  TError,
  { sessionId: string; data: UpdateSessionTitleRequest },
  TContext
> => {
  return useMutation(
    getPatchV2UpdateSessionTitleMutationOptions(options),
    queryClient,
  );
};
export type postChatSynthesizeResponse200 = {
  data: Blob;
  status: 200;
};

export type postChatSynthesizeResponse400 = {
  data: void;
  status: 400;
};

export type postChatSynthesizeResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postChatSynthesizeResponse402 = {
  data: void;
  status: 402;
};

export type postChatSynthesizeResponse404 = {
  data: void;
  status: 404;
};

export type postChatSynthesizeResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postChatSynthesizeResponse429 = {
  data: void;
  status: 429;
};

export type postChatSynthesizeResponse503 = {
  data: void;
  status: 503;
};

export type postChatSynthesizeResponseSuccess =
  postChatSynthesizeResponse200 & {
    headers: Headers;
  };
export type postChatSynthesizeResponseError = (
  | postChatSynthesizeResponse400
  | postChatSynthesizeResponse401
  | postChatSynthesizeResponse402
  | postChatSynthesizeResponse404
  | postChatSynthesizeResponse422
  | postChatSynthesizeResponse429
  | postChatSynthesizeResponse503
) & {
  headers: Headers;
};

export type postChatSynthesizeResponse =
  | postChatSynthesizeResponseSuccess
  | postChatSynthesizeResponseError;

export const getPostChatSynthesizeUrl = () => {
  return `/api/chat/speech`;
};

/**
 * Return *text* as MP3 audio, charging the caller for the synthesis.
 * @summary Synthesize
 */
export const postChatSynthesize = async (
  speechRequest: SpeechRequest,
  options?: RequestInit,
): Promise<postChatSynthesizeResponse> => {
  return customMutator<postChatSynthesizeResponse>(getPostChatSynthesizeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(speechRequest),
  });
};

export const getPostChatSynthesizeMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postChatSynthesize>>,
    TError,
    { data: SpeechRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postChatSynthesize>>,
  TError,
  { data: SpeechRequest },
  TContext
> => {
  const mutationKey = ["postChatSynthesize"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postChatSynthesize>>,
    { data: SpeechRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postChatSynthesize(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostChatSynthesizeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postChatSynthesize>>
>;
export type PostChatSynthesizeMutationBody = SpeechRequest;
export type PostChatSynthesizeMutationError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Synthesize
 */
export const usePostChatSynthesize = <
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postChatSynthesize>>,
      TError,
      { data: SpeechRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postChatSynthesize>>,
  TError,
  { data: SpeechRequest },
  TContext
> => {
  return useMutation(
    getPostChatSynthesizeMutationOptions(options),
    queryClient,
  );
};
export type getV2GetSuggestedPromptsResponse200 = {
  data: SuggestedPromptsResponse;
  status: 200;
};

export type getV2GetSuggestedPromptsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetSuggestedPromptsResponseSuccess =
  getV2GetSuggestedPromptsResponse200 & {
    headers: Headers;
  };
export type getV2GetSuggestedPromptsResponseError =
  getV2GetSuggestedPromptsResponse401 & {
    headers: Headers;
  };

export type getV2GetSuggestedPromptsResponse =
  | getV2GetSuggestedPromptsResponseSuccess
  | getV2GetSuggestedPromptsResponseError;

export const getGetV2GetSuggestedPromptsUrl = () => {
  return `/api/chat/suggested-prompts`;
};

/**
 * Get LLM-generated suggested prompts grouped by theme.
 *
 * Returns personalized quick-action prompts based on the user's
 * business understanding. Returns empty themes list if no custom
 * prompts are available.
 * @summary Get Suggested Prompts
 */
export const getV2GetSuggestedPrompts = async (
  options?: RequestInit,
): Promise<getV2GetSuggestedPromptsResponse> => {
  return customMutator<getV2GetSuggestedPromptsResponse>(
    getGetV2GetSuggestedPromptsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSuggestedPromptsQueryKey = () => {
  return [`/api/chat/suggested-prompts`] as const;
};

export const getGetV2GetSuggestedPromptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetSuggestedPromptsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>
  > = ({ signal }) => getV2GetSuggestedPrompts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSuggestedPromptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>
>;
export type GetV2GetSuggestedPromptsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetSuggestedPrompts<
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSuggestedPrompts<
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSuggestedPrompts<
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Suggested Prompts
 */

export function useGetV2GetSuggestedPrompts<
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSuggestedPromptsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Suggested Prompts
 */
export const prefetchGetV2GetSuggestedPromptsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSuggestedPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSuggestedPromptsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListChatTransportsResponse200 = {
  data: ChatTransportsResponse;
  status: 200;
};

export type getV2ListChatTransportsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListChatTransportsResponseSuccess =
  getV2ListChatTransportsResponse200 & {
    headers: Headers;
  };
export type getV2ListChatTransportsResponseError =
  getV2ListChatTransportsResponse401 & {
    headers: Headers;
  };

export type getV2ListChatTransportsResponse =
  | getV2ListChatTransportsResponseSuccess
  | getV2ListChatTransportsResponseError;

export const getGetV2ListChatTransportsUrl = () => {
  return `/api/chat/transports`;
};

/**
 * Every transport the user can chat over.
 *
 * Exactly one carries ``default: true`` — the connection this user chose in
 * Settings, or the server's own pick when they haven't chosen one.
 * @summary List Chat Transports
 */
export const getV2ListChatTransports = async (
  options?: RequestInit,
): Promise<getV2ListChatTransportsResponse> => {
  return customMutator<getV2ListChatTransportsResponse>(
    getGetV2ListChatTransportsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListChatTransportsQueryKey = () => {
  return [`/api/chat/transports`] as const;
};

export const getGetV2ListChatTransportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListChatTransports>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListChatTransportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListChatTransports>>
  > = ({ signal }) => getV2ListChatTransports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListChatTransports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListChatTransportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListChatTransports>>
>;
export type GetV2ListChatTransportsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2ListChatTransports<
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatTransports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListChatTransports>>,
          TError,
          Awaited<ReturnType<typeof getV2ListChatTransports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListChatTransports<
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatTransports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListChatTransports>>,
          TError,
          Awaited<ReturnType<typeof getV2ListChatTransports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListChatTransports<
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatTransports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Chat Transports
 */

export function useGetV2ListChatTransports<
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatTransports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListChatTransportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Chat Transports
 */
export const prefetchGetV2ListChatTransportsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListChatTransports>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListChatTransports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListChatTransportsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type putV2SetDefaultChatTransportResponse200 = {
  data: ChatTransportsResponse;
  status: 200;
};

export type putV2SetDefaultChatTransportResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV2SetDefaultChatTransportResponse404 = {
  data: void;
  status: 404;
};

export type putV2SetDefaultChatTransportResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV2SetDefaultChatTransportResponseSuccess =
  putV2SetDefaultChatTransportResponse200 & {
    headers: Headers;
  };
export type putV2SetDefaultChatTransportResponseError = (
  | putV2SetDefaultChatTransportResponse401
  | putV2SetDefaultChatTransportResponse404
  | putV2SetDefaultChatTransportResponse422
) & {
  headers: Headers;
};

export type putV2SetDefaultChatTransportResponse =
  | putV2SetDefaultChatTransportResponseSuccess
  | putV2SetDefaultChatTransportResponseError;

export const getPutV2SetDefaultChatTransportUrl = () => {
  return `/api/chat/transports/default`;
};

/**
 * Save the connection every new chat starts on.
 *
 * Applies to chats nobody routed explicitly — a fresh session in the web
 * app, and every conversation that arrives without a request to read a route
 * from: bot links, schedules, briefings, dream passes. It does not touch a
 * conversation that already exists; sessions keep the route they were
 * created with.
 * @summary Set Default Chat Transport
 */
export const putV2SetDefaultChatTransport = async (
  setDefaultTransportRequest: SetDefaultTransportRequest,
  options?: RequestInit,
): Promise<putV2SetDefaultChatTransportResponse> => {
  return customMutator<putV2SetDefaultChatTransportResponse>(
    getPutV2SetDefaultChatTransportUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setDefaultTransportRequest),
    },
  );
};

export const getPutV2SetDefaultChatTransportMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>,
    TError,
    { data: SetDefaultTransportRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>,
  TError,
  { data: SetDefaultTransportRequest },
  TContext
> => {
  const mutationKey = ["putV2SetDefaultChatTransport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>,
    { data: SetDefaultTransportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putV2SetDefaultChatTransport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV2SetDefaultChatTransportMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>
>;
export type PutV2SetDefaultChatTransportMutationBody =
  SetDefaultTransportRequest;
export type PutV2SetDefaultChatTransportMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Set Default Chat Transport
 */
export const usePutV2SetDefaultChatTransport = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>,
      TError,
      { data: SetDefaultTransportRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV2SetDefaultChatTransport>>,
  TError,
  { data: SetDefaultTransportRequest },
  TContext
> => {
  return useMutation(
    getPutV2SetDefaultChatTransportMutationOptions(options),
    queryClient,
  );
};
export type getV2GetCopilotUsageResponse200 = {
  data: CoPilotUsagePublic;
  status: 200;
};

export type getV2GetCopilotUsageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetCopilotUsageResponseSuccess =
  getV2GetCopilotUsageResponse200 & {
    headers: Headers;
  };
export type getV2GetCopilotUsageResponseError =
  getV2GetCopilotUsageResponse401 & {
    headers: Headers;
  };

export type getV2GetCopilotUsageResponse =
  | getV2GetCopilotUsageResponseSuccess
  | getV2GetCopilotUsageResponseError;

export const getGetV2GetCopilotUsageUrl = () => {
  return `/api/chat/usage`;
};

/**
 * Get CoPilot usage status for the authenticated user.
 *
 * Returns the percentage of the daily/weekly allowance used — not the
 * raw spend or cap — so clients cannot derive per-turn cost or platform
 * margins. Global defaults sourced from PostHog (falling back to
 * config). Includes the user's rate-limit tier.
 * @summary Get Copilot Usage
 */
export const getV2GetCopilotUsage = async (
  options?: RequestInit,
): Promise<getV2GetCopilotUsageResponse> => {
  return customMutator<getV2GetCopilotUsageResponse>(
    getGetV2GetCopilotUsageUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetCopilotUsageQueryKey = () => {
  return [`/api/chat/usage`] as const;
};

export const getGetV2GetCopilotUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2GetCopilotUsageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetCopilotUsage>>
  > = ({ signal }) => getV2GetCopilotUsage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetCopilotUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetCopilotUsage>>
>;
export type GetV2GetCopilotUsageQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetCopilotUsage<
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCopilotUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCopilotUsage<
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCopilotUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCopilotUsage<
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Copilot Usage
 */

export function useGetV2GetCopilotUsage<
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetCopilotUsageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Copilot Usage
 */
export const prefetchGetV2GetCopilotUsageQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCopilotUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetCopilotUsageQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2ResetCopilotUsageResponse200 = {
  data: RateLimitResetResponse;
  status: 200;
};

export type postV2ResetCopilotUsageResponse400 = {
  data: void;
  status: 400;
};

export type postV2ResetCopilotUsageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ResetCopilotUsageResponse402 = {
  data: void;
  status: 402;
};

export type postV2ResetCopilotUsageResponse429 = {
  data: void;
  status: 429;
};

export type postV2ResetCopilotUsageResponse503 = {
  data: void;
  status: 503;
};

export type postV2ResetCopilotUsageResponseSuccess =
  postV2ResetCopilotUsageResponse200 & {
    headers: Headers;
  };
export type postV2ResetCopilotUsageResponseError = (
  | postV2ResetCopilotUsageResponse400
  | postV2ResetCopilotUsageResponse401
  | postV2ResetCopilotUsageResponse402
  | postV2ResetCopilotUsageResponse429
  | postV2ResetCopilotUsageResponse503
) & {
  headers: Headers;
};

export type postV2ResetCopilotUsageResponse =
  | postV2ResetCopilotUsageResponseSuccess
  | postV2ResetCopilotUsageResponseError;

export const getPostV2ResetCopilotUsageUrl = () => {
  return `/api/chat/usage/reset`;
};

/**
 * Reset the daily CoPilot rate limit by spending credits.
 *
 * Allows users who have hit their daily cost limit to spend credits
 * to reset their daily usage counter and continue working.
 * Returns 400 if the feature is disabled or the user is not over the limit.
 * Returns 402 if the user has insufficient credits.
 * @summary Reset Copilot Usage
 */
export const postV2ResetCopilotUsage = async (
  options?: RequestInit,
): Promise<postV2ResetCopilotUsageResponse> => {
  return customMutator<postV2ResetCopilotUsageResponse>(
    getPostV2ResetCopilotUsageUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2ResetCopilotUsageMutationOptions = <
  TError = void | HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ResetCopilotUsage>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ResetCopilotUsage>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV2ResetCopilotUsage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ResetCopilotUsage>>,
    void
  > = () => {
    return postV2ResetCopilotUsage(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ResetCopilotUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ResetCopilotUsage>>
>;

export type PostV2ResetCopilotUsageMutationError =
  void | HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Reset Copilot Usage
 */
export const usePostV2ResetCopilotUsage = <
  TError = void | HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ResetCopilotUsage>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ResetCopilotUsage>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV2ResetCopilotUsageMutationOptions(options),
    queryClient,
  );
};
export type getV2GetSharedChatResponse200 = {
  data: SharedChatSession;
  status: 200;
};

export type getV2GetSharedChatResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetSharedChatResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetSharedChatResponseSuccess =
  getV2GetSharedChatResponse200 & {
    headers: Headers;
  };
export type getV2GetSharedChatResponseError = (
  | getV2GetSharedChatResponse404
  | getV2GetSharedChatResponse422
) & {
  headers: Headers;
};

export type getV2GetSharedChatResponse =
  | getV2GetSharedChatResponseSuccess
  | getV2GetSharedChatResponseError;

export const getGetV2GetSharedChatUrl = (shareToken: string) => {
  return `/api/public/shared/chats/${shareToken}`;
};

/**
 * @summary Get Shared Chat
 */
export const getV2GetSharedChat = async (
  shareToken: string,
  options?: RequestInit,
): Promise<getV2GetSharedChatResponse> => {
  return customMutator<getV2GetSharedChatResponse>(
    getGetV2GetSharedChatUrl(shareToken),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSharedChatQueryKey = (shareToken: string) => {
  return [`/api/public/shared/chats/${shareToken}`] as const;
};

export const getGetV2GetSharedChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetSharedChatQueryKey(shareToken);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetSharedChat>>
  > = ({ signal }) =>
    getV2GetSharedChat(shareToken, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: shareToken !== null && shareToken !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSharedChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSharedChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSharedChat>>
>;
export type GetV2GetSharedChatQueryError = void | HTTPValidationError;

export function useGetV2GetSharedChat<
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSharedChat>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSharedChat>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSharedChat<
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSharedChat>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSharedChat>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSharedChat<
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Shared Chat
 */

export function useGetV2GetSharedChat<
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSharedChatQueryOptions(shareToken, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Shared Chat
 */
export const prefetchGetV2GetSharedChatQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSharedChat>>,
  TError = void | HTTPValidationError,
>(
  queryClient: QueryClient,
  shareToken: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChat>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSharedChatQueryOptions(shareToken, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type downloadSharedChatFileResponse200 = {
  data: unknown;
  status: 200;
};

export type downloadSharedChatFileResponse404 = {
  data: void;
  status: 404;
};

export type downloadSharedChatFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type downloadSharedChatFileResponseSuccess =
  downloadSharedChatFileResponse200 & {
    headers: Headers;
  };
export type downloadSharedChatFileResponseError = (
  | downloadSharedChatFileResponse404
  | downloadSharedChatFileResponse422
) & {
  headers: Headers;
};

export type downloadSharedChatFileResponse =
  | downloadSharedChatFileResponseSuccess
  | downloadSharedChatFileResponseError;

export const getDownloadSharedChatFileUrl = (
  shareToken: string,
  fileId: string,
) => {
  return `/api/public/shared/chats/${shareToken}/files/${fileId}/download`;
};

/**
 * Download a workspace file allowlisted by a shared chat (no auth).
 *
 * Returns uniform 404 for every failure mode to prevent enumeration —
 * indistinguishable from "unknown token" or "wrong file id".
 * @summary Download a file from a shared chat
 */
export const downloadSharedChatFile = async (
  shareToken: string,
  fileId: string,
  options?: RequestInit,
): Promise<downloadSharedChatFileResponse> => {
  return customMutator<downloadSharedChatFileResponse>(
    getDownloadSharedChatFileUrl(shareToken, fileId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDownloadSharedChatFileQueryKey = (
  shareToken: string,
  fileId: string,
) => {
  return [
    `/api/public/shared/chats/${shareToken}/files/${fileId}/download`,
  ] as const;
};

export const getDownloadSharedChatFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadSharedChatFileQueryKey(shareToken, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadSharedChatFile>>
  > = ({ signal }) =>
    downloadSharedChatFile(shareToken, fileId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      shareToken !== null &&
      shareToken !== undefined &&
      fileId !== null &&
      fileId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSharedChatFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSharedChatFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSharedChatFile>>
>;
export type DownloadSharedChatFileQueryError = void | HTTPValidationError;

export function useDownloadSharedChatFile<
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSharedChatFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSharedChatFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadSharedChatFile<
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSharedChatFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSharedChatFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadSharedChatFile<
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download a file from a shared chat
 */

export function useDownloadSharedChatFile<
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadSharedChatFileQueryOptions(
    shareToken,
    fileId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download a file from a shared chat
 */
export const prefetchDownloadSharedChatFileQuery = async <
  TData = Awaited<ReturnType<typeof downloadSharedChatFile>>,
  TError = void | HTTPValidationError,
>(
  queryClient: QueryClient,
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedChatFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadSharedChatFileQueryOptions(
    shareToken,
    fileId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetSharedChatMessagesResponse200 = {
  data: SharedChatMessagesPage;
  status: 200;
};

export type getV2GetSharedChatMessagesResponse400 = {
  data: void;
  status: 400;
};

export type getV2GetSharedChatMessagesResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetSharedChatMessagesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetSharedChatMessagesResponseSuccess =
  getV2GetSharedChatMessagesResponse200 & {
    headers: Headers;
  };
export type getV2GetSharedChatMessagesResponseError = (
  | getV2GetSharedChatMessagesResponse400
  | getV2GetSharedChatMessagesResponse404
  | getV2GetSharedChatMessagesResponse422
) & {
  headers: Headers;
};

export type getV2GetSharedChatMessagesResponse =
  | getV2GetSharedChatMessagesResponseSuccess
  | getV2GetSharedChatMessagesResponseError;

export const getGetV2GetSharedChatMessagesUrl = (
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/public/shared/chats/${shareToken}/messages?${stringifiedParams}`
    : `/api/public/shared/chats/${shareToken}/messages`;
};

/**
 * @summary Get Shared Chat Messages
 */
export const getV2GetSharedChatMessages = async (
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: RequestInit,
): Promise<getV2GetSharedChatMessagesResponse> => {
  return customMutator<getV2GetSharedChatMessagesResponse>(
    getGetV2GetSharedChatMessagesUrl(shareToken, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSharedChatMessagesQueryKey = (
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
) => {
  return [
    `/api/public/shared/chats/${shareToken}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetSharedChatMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetSharedChatMessagesQueryKey(shareToken, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetSharedChatMessages>>
  > = ({ signal }) =>
    getV2GetSharedChatMessages(shareToken, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: shareToken !== null && shareToken !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSharedChatMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSharedChatMessages>>
>;
export type GetV2GetSharedChatMessagesQueryError = void | HTTPValidationError;

export function useGetV2GetSharedChatMessages<
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  params: undefined | GetV2GetSharedChatMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSharedChatMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSharedChatMessages<
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSharedChatMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSharedChatMessages<
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Shared Chat Messages
 */

export function useGetV2GetSharedChatMessages<
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSharedChatMessagesQueryOptions(
    shareToken,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Shared Chat Messages
 */
export const prefetchGetV2GetSharedChatMessagesQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
  TError = void | HTTPValidationError,
>(
  queryClient: QueryClient,
  shareToken: string,
  params?: GetV2GetSharedChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSharedChatMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSharedChatMessagesQueryOptions(
    shareToken,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
